import { ReactComponent } from 'models/ReactComponent';
import { ProductAttribute } from 'models/ProductAttribute';
import { hasElements } from 'utils';
import { RedReview } from 'models/RedReview';
import { Faq } from 'models/Faq';

interface HasReviewsProps {
  reviews: RedReview[] | undefined;
}

export const getHasReviews = ({ reviews }: HasReviewsProps): boolean => hasElements(reviews);

interface HasAttributesProps {
  attributes: ProductAttribute[][] | undefined;
}

export const getHasAttributes = ({ attributes }: HasAttributesProps): boolean =>
  hasElements(attributes);

interface HasShortDescriptionProps {
  shortDescription: ReactComponent | undefined;
}

export const getHasShortDescription = ({ shortDescription }: HasShortDescriptionProps): boolean => {
  if (shortDescription && shortDescription.content) {
    return shortDescription.content.length > 0;
  }

  return false;
};

interface HasDescriptionProps {
  description: ReactComponent | undefined;
}

export const getHasDescription = ({ description }: HasDescriptionProps): boolean => {
  if (description && description.content) {
    return description.content.length > 0;
  }

  return false;
};

interface HasFaqsProps {
  faqs: Faq[] | undefined;
}

export const getHasFaq = ({ faqs }: HasFaqsProps): boolean => hasElements(faqs);
